import React, { useEffect } from 'react';
import { Download, ArrowLeft } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import Header from './Header';
import Footer from './Footer';

const BRAND_T = {
  en: {
    title: 'Brand Review',
    subtitle: 'Official brandbook — download below. More materials will be added here later.',
    download: 'Download brandbook',
    back: 'Back to homepage',
  },
  es: {
    title: 'Brand Review',
    subtitle: 'Brandbook oficial — descarga abajo. Más materiales se añadirán aquí más adelante.',
    download: 'Descargar brandbook',
    back: 'Volver al inicio',
  },
  he: {
    title: 'Brand Review',
    subtitle: 'ספר מותג רשמי — הורד למטה. חומרים נוספים יתווספו כאן בהמשך.',
    download: 'הורדת ספר המותג',
    back: 'חזור לדף הבית',
  },
};

const BRAND_FILE = `${process.env.PUBLIC_URL || ''}/h2-element-brandbook.pdf`;

export default function BrandReviewPage() {
  const { lang } = useLanguage();
  const lt = BRAND_T[lang] || BRAND_T.en;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#0a0a0f] flex flex-col">
      <Header />

      <section className="relative flex-1 pt-28 pb-20 overflow-hidden">
        <div className="absolute inset-0 cyber-grid opacity-15" />
        <div className="absolute top-24 right-1/4 w-72 h-72 bg-[#00f0ff]/5 rounded-full blur-[100px]" />
        <div className="absolute bottom-20 left-1/3 w-64 h-64 bg-[#39ff14]/5 rounded-full blur-[100px]" />

        <div className="relative max-w-xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <a
            href="/"
            className="inline-flex items-center gap-2 text-[#00f0ff]/60 hover:text-[#00f0ff] text-xs mb-10 transition-colors"
            style={{ fontFamily: 'Share Tech Mono' }}
          >
            <ArrowLeft size={12} /> {lt.back}
          </a>

          <h1 className="text-3xl md:text-4xl font-black text-white mb-4" style={{ fontFamily: 'Orbitron' }}>
            {lt.title}
          </h1>
          <p className="text-white/45 text-sm mb-10 leading-relaxed">{lt.subtitle}</p>

          <a
            href={BRAND_FILE}
            download="H2-Element-Brandbook.pdf"
            className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-[#39ff14] text-[#0a0a0f] font-bold text-xs tracking-[0.2em] transition-all hover:shadow-[0_0_28px_rgba(57,255,20,0.35)]"
            style={{ fontFamily: 'Orbitron' }}
          >
            <Download size={16} /> {lt.download}
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
}
